const env = process.env;
const host =
  env.NODE_ENV == "development" ? env.REACT_APP_ORIGIN : window.location.host;
export default host;
